import { useEffect, useMemo, useState } from "react";
import "./rightpanel.css";
import "@esri/calcite-components/components/calcite-block";
import "@esri/calcite-components/components/calcite-fab";
import brnoLogo from "./../assets/images/brno_logo.png";
import Widgets from "./../widgets/Widgets.jsx";
import "@esri/calcite-components/components/calcite-tooltip";
import "@esri/calcite-components/components/calcite-link";
import PopUp from "./PopUp.js";

import texts from "../assets/texts/texts.js";
import Description from "../widgets/Description.jsx";
import useIsMobile from "./MobileDetection.jsx";

// Layers selectors
const nameOf3DLayer = "3D model budov";
const nameOfTreeLayer = "3D model stromů";

function RightBar({ view }) {
  const [visibilityToolspanel, setVisibilityToolspanel] = useState(false);
  const [selectedIndex, setSlectedIndex] = useState(0);
  const [viewRedy, setViewRedy] = useState(false);
  const [widgetsArray, setWidgetsArray] = useState(false);
  const isMobile = useIsMobile();
  const [projectListInput, setProjectListInput] = useState(null);
  const visibleHandler = (index) => {
    if (visibilityToolspanel) {
      setVisibilityToolspanel(false);
    } else {
      setVisibilityToolspanel(true);
      setSlectedIndex(index);
    }
  };

  const widgets = Widgets({ projectListInput, setProjectListInput });
  useEffect(() => {
    if (viewRedy === false && view) {
      setViewRedy(true);

      setWidgetsArray(widgets);

      view.view.when(() => {

        
        // Change layers names
        view.view.map.layers._items.find(
          (o) => o.title === nameOf3DLayer,
        ).title = texts.layers.buildings;
        const layer = view.view.map.layers._items.find(
          (o) => o.title === nameOfTreeLayer,
        );

        view.view.map.layers._items.find(
          (o) => o.title === nameOfTreeLayer,
        ).title = texts.layers.trees;
        // Set PopUp template
        const renderer = layer.renderer.clone();

        // Prevent to 0 value in vyska_taxonu atributs
        renderer.visualVariables = [
          {
            type: "size",
            axis: "height",
            valueUnit: "meters",
            valueExpression:
              "var h = DefaultValue($feature.vyska_taxonu, 0); if (h > 0) { return h; } var t = DefaultValue($feature.cd_nazev, ''); if (Find('keře', Lower(t)) >= 0) { return 5; } return 15;",
          },
        ];

        layer.renderer = renderer;

        PopUp(view.view);
      });
    }
  }, [view]);

  return (
    <>
      {visibilityToolspanel && widgetsArray && (
        <div id="toolspanel">
          <calcite-fab
            class="closebutton"
            appearance="outline-fill"
            icon="x"
            label="Zavřít panel"
            onClick={() => {
              visibleHandler(null);
            }}
          ></calcite-fab>
          <div className="toolspanel__tools">
            {widgetsArray.map((item, index) => (
              <div key={"widgets_" + index}>
                <calcite-block
                  collapsible
                  heading={item.label}
                  scale="l"
                  open={selectedIndex === index ? true : false}
                >
                  <calcite-icon
                    icon={item.icon}
                    scale="m"
                    slot="icon"
                  ></calcite-icon>
                  {item.objekt()}
                  <calcite-action
                    id={"infoUpload_" + index}
                    slot="control"
                    texts="Information"
                    icon="information"
                    title={"Návod: " + item.label}
                  ></calcite-action>
                </calcite-block>

                <calcite-popover
                  label="This is a new feature"
                  placement="left"
                  reference-element={"infoUpload_" + index}
                >
                  <div className="popover-row">
                    <calcite-icon
                      icon="information"
                      text-label="Information"
                      scale="s"
                    ></calcite-icon>
                    <Description type={item} marginTop="0" />
                  </div>
                </calcite-popover>
              </div>
            ))}
          </div>
        </div>
      )}
      {!visibilityToolspanel && widgetsArray && (
        <>
          <div id="rightpanel">
            {widgetsArray.map((item, index) => (
              <span key={"rightpanel" + index}>
                <calcite-button
                  className="rightpanel__button rightpanel__button_icons"
                  scale="s"
                  onClick={() => {
                    visibleHandler(index);
                  }}
                  id={rightButtonIDName(item.label)}
                >
                  <calcite-icon icon={item.icon} scale="l"></calcite-icon>
                </calcite-button>
                {!isMobile && (
                  <calcite-tooltip
                    key={"rightpaneltooltip" + index}
                    reference-element={rightButtonIDName(item.label)}
                  >
                    <span className="my-tooltip-text">{item.label}</span>
                  </calcite-tooltip>
                )}
              </span>
            ))}

            <calcite-button
              id="rightPanelHamburger"
              className="rightpanel__button rightpanel__button_hamburger"
              scale="s"
              onClick={() => {
                visibleHandler("");
              }}
            >
              <calcite-icon icon="hamburger" scale="l"></calcite-icon>
            </calcite-button>
          </div>
          <calcite-link
            className="foterLogoBrno"
            href="https://www.brno.cz/"
            target="_blank"
            alt="Brno logo"
          >
            <img className="logoBrno" src={brnoLogo} alt="Brno Logo" />
          </calcite-link>
        </>
      )}
    </>
  );
}

export default RightBar;

function removeDiacriticsAndSpecialCharacters(str) {
  // Remove diacritics by converting accented characters to their base form
  const normalizedStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // Remove all non-alphanumeric characters
  const cleanedStr = normalizedStr.replace(/[^a-zA-Z0-9]/g, "");

  // Resource to lowercase
  return cleanedStr.toLowerCase();
}

function rightButtonIDName(str) {
  return "rightPanelButton" + removeDiacriticsAndSpecialCharacters(str);
}
